var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-select',{attrs:{"title":"РЕГИОН:","form-group":"","form-group-margin-bottom":_vm.formGroupMarginBottom,"options":_vm.getRegions,"value":_vm.selectedRegion,"disabled":_vm.getRegions.length === 1},on:{"input":function($event){return _vm.changeSelectedRegion($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }